if (!window.customElements.get('featured-product-carousel')) {
  class FeaturedProductCarousel extends HTMLElement {
    constructor() {
      super();
      this.swiperEl = this.querySelector('.featured-product-carousel__swiper');
      this.paginationEl = this.querySelector('.featured-product-carousel__pagination');
    }

    connectedCallback() {
      if (!this.swiperEl) return;
      this.initSwiper();
    }

    initSwiper() {
      const config = {
        modules: [],
        loop: false,
        autoplay: {
          delay: 4000,
          disableOnInteraction: true
        }
      };

      if (this.paginationEl) {
        config.pagination = {
          el: this.paginationEl,
          clickable: true,
          bulletClass: 'featured-product-carousel-pagination-bullet',
          bulletActiveClass: 'featured-product-carousel-pagination-bullet-active'
        };
      }
      
      const nextEl = this.querySelector('.featured-product-carousel__next');
      const prevEl = this.querySelector('.featured-product-carousel__prev');

      if (nextEl && prevEl) {
          config.navigation = {
            nextEl: nextEl,
            prevEl: prevEl,
          };
      }

      this.swiper = new Swiper(this.swiperEl, config);
    }
  }

  customElements.define('featured-product-carousel', FeaturedProductCarousel);
}

